module.exports = __webpack_public_path__ + "img/bk_18_01.27b43fcd.png";